import { render, staticRenderFns } from "./ClassroomDetailGroupAddNew.vue?vue&type=template&id=d7a31dd0&scoped=true"
import script from "./ClassroomDetailGroupAddNew.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailGroupAddNew.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailGroupAddNew.vue?vue&type=style&index=0&id=d7a31dd0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a31dd0",
  null
  
)

export default component.exports